import areaTreeData from './area-2020-12.json'
import {getPinyinFirstChar} from "@/utils/pinyinUtils";

let areaTree = areaTreeData;
let areaMapping = {}; // code:data
let que = [];
que.push(...  areaTreeData);
while(que.length>0){
  let node =que.pop();
  let py =getPinyinFirstChar(node.name)
  node.pinyin=py
  areaMapping[node.code]=node;
  if(node.children){
    node.children.forEach(e=>e.parent=node);
    que.push(... node.children);
  }
}
export {areaMapping,areaTree}
